var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._g(_vm._b({attrs:{"depressed":"","color":_vm.$attrs.color ? _vm.$attrs.color : 'secondary',"block":_vm.block,"type":"submit"}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.$t('common:continue'))+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }